import { Injectable } from '@angular/core';
import {ToastType} from "./toast.component";

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: Toast[] = []
  constructor() { }

  show(message: string, type: ToastType = ToastType.SUCCESS, duration: number = 3000) {
    this.toasts.push({ message, type });
    if(this.toasts.length > 3) {
      this.toasts.shift()
    }
    setTimeout(() => {
      this.toasts.shift()
    }, duration)
  }

  remove(index: number) {
    this.toasts.splice(index, 1)
  }
}

export interface Toast {
  message: string
  type: ToastType
}
